import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@americanexpress/dls-react";
import "./Timer.css";

class Timer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      minutes: 0,
      seconds: 0,
      show: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    if (this.props.time === "0") {
      this.setState({
        minutes: localStorage.getItem("minutes"),
        seconds: localStorage.getItem("seconds"),
      });
    }
    if (this.props.time === "1") {
      this.setState({ minutes: 20, seconds: 0 });
    }

    this.myInterval = setInterval(() => {
      const { seconds, minutes } = this.state;

      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1,
        }));
      }
      if (seconds <= 1) {
        if (minutes === 5 && seconds <= 1) {
          this.toggleModal();
        }
        this.setState(({ minutes }) => ({
          minutes: minutes - 1,
          seconds: 59,
        }));
        if (minutes <= 0) {
          clearInterval(this.myInterval);
          this.props.hist.push("/");
        }
      }
    }, 1000);
  }

  toggleModal = () => this.setState({ show: !this.state.show });

  continue = () => {
    this.setState(({ minutes }) => ({
      minutes: 20,
      seconds: 0,
    }));
    this.toggleModal();
  };

  componentWillUpdate(nextProps, nextState) {
    localStorage.setItem("minutes", this.state.minutes);
    localStorage.setItem("seconds", this.state.seconds);
  }

  render() {
    const { t } = this.props;
    const { seconds, minutes, show } = this.state;
    return (
      <>
        <span className="time body-1">
          {t("access.timeleft")} : {minutes} {t("access.mins")} :
          {seconds < 10 ? `0${seconds}` : seconds} {t("access.secs")}
        </span>

        {show && (
          <Modal className="sessionExpiryModal">
            <ModalHeader onClose={this.toggleModal}>
              <h2 className="fluid heading-3">{t("modal.timeout")}</h2>
            </ModalHeader>
            <ModalBody className="modalBody">
              <h2 className=" margin-3-b pad-3-t">Your Session is Expiring</h2>
              <div className="pad-2-b">
                <div className="pad-2-b">{t("modal.timeOutText1")}</div>
                <div className="pad-2-b">{t("modal.timeOutText2")}</div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button styleType="primary" onClick={this.continue}>
                {t("modal.continue")}
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </>
    );
  }
}

export default withTranslation("common")(Timer);
